import React from 'react'
import Superface from '../Superface'
import Swiper from 'swiper'
import {addClass} from '../kit'

export default class GallerySmall extends React.Component{

    componentWillMount(){
        this.images_loaded  = 0
        this.setState({
            loaded : false,
            activeIndex : 0
        })
    }

    initSlider(){
        
        if( this.swiper ) return
        
        addClass( this.slider, 'slider-' + this.props.i )
        addClass( this.pagination, 'pagination-' + this.props.i )

        const params = { 
            speed : 400,
            // loop : true,
        }
        
        setTimeout( () => {
            this.swiper = new Swiper('.slider-' + this.props.i , params)
            this.swiper.on('slideChange', () => {
                this.setState({
                    ...this.state,
                    activeIndex : this.swiper.activeIndex
                })
              });
        }, 500)
        
    }
    
    renderMedias(slides){
        return slides.map( (slide, i) => {
            // console.log('PATH ' + slide.path)
            // console.log('MODIFIED PATH ' + Superface.assetUrl(slide.path))
            return(
                <div key={i} 
                    className="swiper-slide"
                    style={{display:'inline-block'}}
                    >
                    <img alt={this.props.name} src={Superface.assetUrl(slide.path)} onLoad={ () => {
                        this.images_loaded ++
                        // console.log( this.images_loaded + '/' + this.props.slides.length )
                        if( this.images_loaded === this.props.slides.length ){
                            this.setState({loaded : true})
                            this.initSlider()
                        }
                    }} />
                </div>
            )
        })
    }

    render(){
        return(

            <div style={{display:'block', backgroundColor:'white', position:'relative'}}>
            
                <div ref={ slider => this.slider = slider } className={"swiper-container swiper-small " + this.props.name }>
                    <div className="swiper-wrapper">
                        {this.renderMedias(this.props.slides)}
                    </div>
                </div>

                <div ref={ pagination => this.pagination = pagination } className="swiper-pagination">
                    {this.props.slides.map((slide,i) => {
                        return (
                            <span 
                                onClick={() => {
                                    this.swiper.slideTo(i)
                                }}
                                style={{cursor:'pointer'}}
                                key={'slide -' + i} 
                                className={"swiper-pagination-bullet " + (this.state.activeIndex === i ? 'swiper-pagination-bullet-active' : '')}
                                >
                            </span>
                        )
                    })}
                </div>

            </div>
        )
    }
    
}


// WEBPACK FOOTER //
// ./src/components/_GallerySmall.js